import React from 'react';
import ReactDOM from 'react-dom';
import AppWrapper from './AppWrapper';
import {HashRouter} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'prismjs/themes/prism-coy.css';
import Axios from 'axios'

const isAuthenticatedSession = () => {
	const userData = localStorage.getItem('user');
	if (!userData) {
		return false;
	}

	try {
		const parsedUser = JSON.parse(userData);
		return Boolean(parsedUser && Object.keys(parsedUser).length > 0);
	} catch (error) {
		return false;
	}
};

const getAccessToken = () => {
	if (!isAuthenticatedSession()) {
		return null;
	}

	const storedToken = localStorage.getItem('accessToken');
	if (!storedToken) {
		return null;
	}

	try {
		return JSON.parse(storedToken);
	} catch (error) {
		return storedToken;
	}
};

const shouldSkipAuth = (config) => {
	const requestUrl = config && config.url ? config.url : '';
	return requestUrl.includes('/service/api/inefaso/campus-auth/register');
};

const applyAuthToken = () => {
	const token = getAccessToken();
	if (token) {
		Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	} else {
		delete Axios.defaults.headers.common['Authorization'];
	}
};

applyAuthToken();

Axios.interceptors.request.use(
	(config) => {
		const token = getAccessToken();
		if (shouldSkipAuth(config)) {
			if (config.headers) {
				delete config.headers.Authorization;
			}
			return config;
		}

		if (token) {
			config.headers = {
				...(config.headers || {}),
				Authorization: `Bearer ${token}`
			};
		} else if (config.headers) {
			delete config.headers.Authorization;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

ReactDOM.render(
	<HashRouter>
		<AppWrapper></AppWrapper>
	</HashRouter>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
